
import { useSelector } from 'react-redux';
import { updateDeleteParent } from '../../../../../stateManagement/actions/manageCouponActions';
import { Checkbox } from '@mui/material';
import CouponConfigurableLabel from '../../CouponConfigurableLabel';

const DeleteParentCoupon =()=>{
    const {deleteParent} = useSelector((state:any)=>state?.manageCoupons?.data)

    const {couponEditType} = useSelector((state:any)=>state.manageCoupons?.data);

    return(
           couponEditType=="clone" && 
        couponEditType && couponEditType==="clone" && (<>
            <div className="usability-limits-checkbox-wrapper">
        <CouponConfigurableLabel text='CONFIRM_PUBLISH_ON_CLONE' />
        <Checkbox  checked={deleteParent} onChange={(e) => { updateDeleteParent(e.target.checked)}} />
        </div>
        </>
))
}
export default DeleteParentCoupon